<template>
    <v-calendar
        :events="events"
        :event-color="getEventColor"
        :start="startDate"
        type="month"
        locale="ja-jp"
        :day-format="timestamp => new Date(timestamp.date).getDate()"
        :month-format="timestamp => (new Date(timestamp.date).getMonth() + 1) + ' /'"
        @click:event="onClickEvent" />
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    export default {
        props: {
            /**
             * 表示対象年月
             */
            targetMonth: {
                type: Object,
                default: function () {
                    return {year:2020, month:1}
                }
            },
            /**
             * 終了した予定を表示するか否か
             */
            viewCompletedWork: {
                type: Boolean,
                default: false
            },
            /**
             * 対象の場所
             */
            place: null,
            /**
             * 登録されている全作業種類
             */
            workTypes: null
        },
        data: function () {
            return {
                startDate: (new Date()).toFormatString("yyyy-MM-dd"),
                /** カレンダーのイベント */
                events: []
            }
        },
        watch: {
            /**
             * 変更監視:対象年
             */
            "targetMonth.year": function () {
                this.refresh()
            },
            /**
             * 変更監視:対象月
             */
            "targetMonth.month": function () {
                this.refresh()
            },
            /**
             * 変更監視:終了作業の表示/非表示
             */
            viewCompletedWork: function () {
                this.refresh()
            },
            /**
             * 変更監視:表示対象の作業
             */
            viewTargetWorks: function () {
                this.refresh()
            },
            /**
             * 変更監視:場所が持つ全作業
             */
            "place.works": {
                handler: function (value, old) {
                    this.refresh()
                },
                deep: true
            },
            /**
             * 変更監視:登録されている作業種類
             */
            workTypes: {
                handler: function (value, old) {
                    this.refresh()
                },
                deep: true
            }
        },
        mounted: function () {
            this.refresh()
        },
        methods: {
            /**
             * 作業記録押下時
             */
            onClickEvent: function ({nativeEvent, event}) {
                this.$emit(
                    "onClickCalendarWorkRecord", 
                    {
                        work: event.work,
                        record: event.record
                    }
                )
            },
            /**
             * イベントの色を返す
             */
            getEventColor: function (event) {
                return event.color
            },
            /**
             * 表示内容を更新
             */
            refresh: function () {
                const self = this
                
                this.startDate = (new Date(this.targetMonth.year, this.targetMonth.month - 1, 1)).toFormatString("yyyy-MM-dd")

                const endDate = (new Date(this.targetMonth.year, this.targetMonth.month, 0)).toFormatString("yyyy-MM-dd")

                this.events = []

                console.log("CalendarPlaceWork", "refresh", self.startDate, endDate, this.events)

                if (this.place == null) {
                    return
                }

                const colors = [
                    "red", 
                    "pink", 
                    "purple", 
                    "deep-purple", 
                    "indigo", 
                    "blue", 
                    "light-blue", 
                    "cyan", 
                    "teal", 
                    "green", 
                    "light-green", 
                    "lime", 
                    "yellow", 
                    "amber", 
                    "orange", 
                    "deep-orange", 
                    "brown", 
                    "blue-grey", 
                    "grey"
                ]
                var colorIndex = 0

                this.place.works.forEach(function(work) {
                    if (!work.isCompleted || self.viewCompletedWork) {
                        const targetMonthWorkRecords = work.records.filter((v)=>v.date >= self.startDate && v.date <= endDate)
                        targetMonthWorkRecords.forEach(function(record) {
                            const event = {
                                name: work.name,
                                start: record.date,
                                end: record.date,
                                color: colors[colorIndex],
                                work: work,
                                record: record
                            }
                            self.events.push(event)
                        })
                    }
                    colorIndex++
                    if (colorIndex == colors.length) colorIndex = 0
                })
            }
        }
    }
</script>
